// Dynamic import required here to avoid "loadShareSync" error
(async () => {
  const {default: waitForSharedModules} = await import(
    "./utils/waitForSharedModules"
  );
  await waitForSharedModules();

  const {default: bootstrap} = await import("./bootstrap");
  const {default: remoteApps} = await import("./config/remoteApps");
  bootstrap(remoteApps);
})();
